// src/components/admin/TestimonialsManager.js
import { FiStar, FiTrash2, FiMessageSquare, FiTrendingUp } from 'react-icons/fi';
import { useTestimonials } from '../../hooks/useTestimonials';
import { useApiAuth } from '../../hooks/useApiAuth';

function TestimonialsManager() {
  const { testimonials, removeTestimonial, satisfaction } = useTestimonials();
  const { authFetch } = useApiAuth();

  const avgRating = testimonials.length
    ? (testimonials.reduce((sum, t) => sum + t.rating, 0) / testimonials.length).toFixed(1)
    : '—';

  return (
    <>
      <div className="admin-stats">
        <div className="admin-stat-card">
          <FiMessageSquare size={18} className="admin-stat-icon" />
          <span className="admin-stat-number">{testimonials.length}</span>
          <span className="admin-stat-label">Total Reviews</span>
        </div>
        <div className="admin-stat-card">
          <FiTrendingUp size={18} className="admin-stat-icon" />
          <span className="admin-stat-number">{satisfaction}%</span>
          <span className="admin-stat-label">Satisfaction Rate</span>
        </div>
        <div className="admin-stat-card">
          <FiStar size={18} className="admin-stat-icon" />
          <span className="admin-stat-number">{avgRating}</span>
          <span className="admin-stat-label">Avg. Rating</span>
        </div>
      </div>

      <section className="admin-section">
        <h2 className="admin-section-title">Testimonials</h2>
        <div className="admin-table-wrapper">
          <table className="admin-table">
            <thead>
              <tr>
                <th>Author</th>
                <th>Role</th>
                <th>Rating</th>
                <th>Review</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {testimonials.map(t => (
                <tr key={t.id}>
                  <td className="admin-td-name">{t.name}</td>
                  <td className="admin-td-role">{t.role}</td>
                  <td>
                    <span className="admin-rating">
                      {[...Array(5)].map((_, i) => (
                        <FiStar key={i} size={12} className={i < t.rating ? 'star-filled' : 'star-empty'} />
                      ))}
                    </span>
                  </td>
                  <td className="admin-td-body">"{t.body}"</td>
                  <td>
                    <button className="admin-delete-btn" onClick={() => removeTestimonial(t.id, authFetch)} aria-label="Delete testimonial">
                      <FiTrash2 size={14} />
                    </button>
                  </td>
                </tr>
              ))}
              {testimonials.length === 0 && (
                <tr><td colSpan={5} className="admin-empty">No testimonials yet.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
}

export default TestimonialsManager;
